<div class="flex h-full w-full flex-col overflow-hidden">
  <!-- JSON Editor -->
  <div
    #editorContainer
    class="json-editor-container flex-1 overflow-hidden border border-zinc-300 bg-zinc-50 dark:border-zinc-600 dark:bg-zinc-900"
    [class.rounded-t-lg]="errorCount() > 0"
    [class.rounded-lg]="errorCount() === 0"
    [class.border-b-0]="errorCount() > 0"></div>
</div>
